import React from 'react';
import { FixedSizeList as List, areEqual } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectFloatingSearchPages, selectFloatingSearchPagesLoading } from 'app/store/DMSDocumentPages/DMSDocumentPages.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import PageCard from '@root/components/PageCard';
// i18next
import { CARD_WIDTH, CARD_HEIGHT } from 'app/App.constants';
import { Loader, Message } from 'app/components/Utilities';

interface IProps {
  enableFullscreen: boolean;
}

export default function DialogSearchResults({ enableFullscreen }: IProps) {
  const pages = useAppSelector(selectFloatingSearchPages);
  const loading = useAppSelector(selectFloatingSearchPagesLoading);

  if ( loading ) return <Loader />
  if ( !pages ) return null;
  if ( !pages.length ) return <Message text="No pages found" />
  return (
    <Box style={{ flexGrow: enableFullscreen ? 1 : 0, position: 'relative', width: '100%', height: enableFullscreen ? 'auto' : '75vh' }}>
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
        <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
          <AutoSizer>
            {({ width, height }: { width: number; height: number }) => {
              const itemsPerRow = Math.floor(width / CARD_WIDTH);
              const itemCount = Math.ceil(pages.length / itemsPerRow);
              const itemSize = CARD_HEIGHT;

              return (
                <List
                  width={width}
                  height={height}
                  itemCount={itemCount}
                  itemSize={itemSize}
                  className="dialogSearchListContainer"
                  initialScrollOffset={0}

                  itemData={{
                    itemsPerRow,
                    pages,
                    itemSize
                  }}
                >
                  {Row}
                </List>
              )
            }}
          </AutoSizer>
        </Box>
      </Box>
    </Box>
  )
}

const Row = React.memo(({ index, style, data:{ itemsPerRow, pages, itemSize, forceReload } }:any) => {
  const items = [];
  const fromIndex = index * itemsPerRow;
  const toIndex = Math.min(fromIndex + itemsPerRow, pages.length);
  for ( let i = fromIndex; i < toIndex; i++ ){
    const page = pages[i];
    items.push(
      <div
        key={`page-item-${page.documentId}-${page.pageNum}-${forceReload}`}
        className="card-page-item"
        style={{
          width: `${(100/itemsPerRow).toFixed(2)}%`,
          marginTop: i < itemsPerRow ? '16px' : 0
        }}
      >
        <PageCard
          scrollContainer=".dialogSearchListContainer"
          documentId={page.documentId}
          pageNum={page.pageNum}
          height={i < itemsPerRow ? itemSize - 32 : itemSize - 16}
          disableBodyClick={true}
          showOnlyCopyAction={true}
        />
      </div>
    );
  }
  return (
    <div
      className="card-page-container"
      style={{ ...style }}
    >{items}</div>
  )
}, areEqual)
